<template>
  <div :class="{ 'content-height': !loaded }">
    <div class="d-none d-lg-block" v-if="courses && courses.length > 0">
      <template v-if="animationCourses.length > 0">
        <div class="h4-style group-title">{{ groupTitle[0] }}</div>
        <div class="row g-0">
          <Course
            v-for="ac in animationCourses"
            :key="ac.title"
            :course="ac"
          ></Course>
        </div>
      </template>
      <template v-if="visualCourses.length > 0">
        <div class="h4-style group-title">{{ groupTitle[1] }}</div>
        <div class="row g-0">
          <Course
            v-for="vc in visualCourses"
            :key="vc.title"
            :course="vc"
          ></Course>
        </div>
      </template>
      <template v-if="fashionCourses.length > 0">
        <div class="h4-style group-title">{{ groupTitle[2] }}</div>
        <div class="row g-0">
          <Course
            v-for="fc in fashionCourses"
            :key="fc.title"
            :course="fc"
          ></Course>
        </div>
      </template>
    </div>
    <div id="courses-mobile" class="d-lg-none" v-if="courses.length > 0">
      <div class="courses-wrapper w-100">
        <template v-for="c in courses" :key="c.title">
          <div class="d-inline-flex courses-unit flex-column text-start">
            <div class="text-start mobile-small w-100">
              {{ groupTitle[c.group - 1] }}
            </div>
            <a :href="c.link" target="_blank">
              <div
                class="w-100 main-image"
                :style="{
                  backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/2021/course/${c.image})`,
                }"
              ></div
            ></a>
            <div class="fw-bold">
              <a :href="c.link" target="_blank">{{ c.title }}</a>
            </div>
            <div class="mobile-small">{{ c.lecturer }}</div>
          </div>
        </template>
      </div>

      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import 'overlayscrollbars/css/OverlayScrollbars.min.css';
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';

import Course from '@/components/online-courses/Course.vue';
import linkArrow from '@/assets/img/link_arrow.png';
import arrowLeft from '@/assets/img/arrow-left.svg';
import arrowRight from '@/assets/img/arrow-right.svg';

// api
import { getOnlineCourseList } from '@/api/onlinecourse';

export default {
  name: 'OnlineCourses',
  components: {
    Course,
  },
  data() {
    return {
      linkArrow,
      arrowLeft,
      arrowRight,
      loaded: false,
      // courses: [{
      //   group: 1,
      //   title: '視覺導演',
      //   lecturer: '范姜仲萱',
      //   image: 'https://placeimg.com/320/320/animal',
      //   link: 'https://www.youtube.com/playlist?list=PL-xQ5bDyFfg_ZGdLN6GN_a7RLxvHHodi4',
      // }, {
      //   group: 1,
      //   title: '概念設計',
      //   lecturer: '陳冠儒',
      //   image: 'https://placeimg.com/320/320/people',
      //   link: 'https://www.youtube.com/playlist?list=PL-xQ5bDyFfg_ZGdLN6GN_a7RLxvHHodi4',
      // }, {
      //   group: 1,
      //   title: '角色動畫',
      //   lecturer: '王宇欣',
      //   image: 'https://placeimg.com/320/320/tech',
      //   link: 'https://www.youtube.com/playlist?list=PL-xQ5bDyFfg_ZGdLN6GN_a7RLxvHHodi4',
      // }, {
      //   group: 2,
      //   title: '設計思考',
      //   lecturer: '鄭仰均',
      //   image: 'https://placeimg.com/320/320/nature',
      //   link: 'https://www.youtube.com/playlist?list=PL-xQ5bDyFfg_ZGdLN6GN_a7RLxvHHodi4',
      // }, {
      //   group: 2,
      //   title: '設幻設計',
      //   lecturer: '黃筠喬',
      //   image: 'https://placeimg.com/320/320/animal',
      //   link: 'https://www.youtube.com/playlist?list=PL-xQ5bDyFfg_ZGdLN6GN_a7RLxvHHodi4',
      // }],
      groupTitle: ['數位動畫組', '視覺傳達設計組', '時尚設計組'],
      courses: [],
    };
  },
  computed: {
    animationCourses() {
      return this.courses.filter((c) => c.group === 1);
    },
    visualCourses() {
      return this.courses.filter((c) => c.group === 2);
    },
    fashionCourses() {
      return this.courses.filter((c) => c.group === 3);
    },
  },
  async mounted() {
    const settings = {
      className: 'os-theme-dark',
      sizeAutoCapable: true,
      paddingAbsolute: true,
      overflowBehavior: {
        x: 'scroll',
        y: 'hidden',
      },
      scrollbars: {
        clickScrolling: true,
        visibility: 'auto',
      },
    };

    // this.$store.commit('setLoadingState', { status: true });
    const filter = { order: 'updated_at desc' };
    await getOnlineCourseList({ filter }).then((response) => {
      this.courses = response;
      this.loaded = true;
      // setTimeout(() => {
      //   this.$store.commit('setLoadingState', { status: false });
      // }, 700);
    });
    const ocScroll = OverlayScrollbars(document.querySelectorAll('.courses-wrapper'), settings);
    document.querySelector('#courses-mobile .scroll-left').addEventListener('click', () => ocScroll.scroll({ x: '-= 300px' }));
    document.querySelector('#courses-mobile .scroll-right').addEventListener('click', () => ocScroll.scroll({ x: '+= 300px' }));
  },
  // created() {},
};
</script>
<style lang="stylus" scoped>
.content-height
  height: 150vh;

.group-title
  margin-bottom: 16px;

.row + .group-title
  margin-top: 48px;

.tag-link
  // border: 2px solid $monoc4;
  // color: $monoc4;
  // border-radius: 100px;
  // padding: 4px 4px 4px 10px;
  // text-decoration: none;
  // font-size: 1rem;
  // line-height: 23px;
  // margin-left: 1px;
  img
    width: 24px;
    margin-left: 8px;

a
  color: $monoc4;
  text-decoration: none;

  &:focus, &:hover, &:active
    color: $monoc4;

.main-image
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 30vh;

#courses-mobile
  position: relative;
  width: 100%;

.courses-wrapper
  padding-bottom: 24px;
  white-space: nowrap;

.courses-unit
  width: 360px;
  white-space: normal;

@media screen and (max-width: 575.7px)
  .courses-unit
    width: 100%;
</style>
